// extracted by mini-css-extract-plugin
export default {"ldsRing":"Spinner_ldsRing__6HWpP","large":"Spinner_large__Eduqc","medium":"Spinner_medium__y9-+i","small":"Spinner_small__R2s5k","lds-ring":"Spinner_lds-ring__E4Ujw"};